import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { AuthLayout } from '@/components/layouts/AuthLayout'

interface LoginProps {
  remember_me_enabled: boolean
}

export default function Login({ remember_me_enabled }: LoginProps) {
  const { data, setData, post, processing, errors } = useForm({
    agent: {
      username: '',
      password: '',
      remember_me: false as boolean,
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/agents/sign_in')
  }

  return (
    <AuthLayout title="Sign in">
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="Username"
          fullWidth
          autoFocus
          autoComplete="username"
          value={data.agent.username}
          onChange={e => setData('agent', { ...data.agent, username: e.target.value })}
          error={'agent.username' in errors}
          helperText={(errors as Record<string, string>)['agent.username']}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          autoComplete="current-password"
          value={data.agent.password}
          onChange={e => setData('agent', { ...data.agent, password: e.target.value })}
          error={'agent.password' in errors}
          helperText={(errors as Record<string, string>)['agent.password']}
          sx={{ mb: 2 }}
        />
        {remember_me_enabled && (
          <FormControlLabel
            control={
              <Checkbox
                checked={data.agent.remember_me}
                onChange={e => setData('agent', { ...data.agent, remember_me: e.target.checked })}
              />
            }
            label="Remember me"
            sx={{ mb: 2 }}
          />
        )}
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mb: 2 }}
        >
          Sign in
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <Link href="/agents/password/new" style={{ color: '#1a1a1a' }}>Forgot your password?</Link>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Don&apos;t have an account?{' '}
            <Link href="/agents/sign_up" style={{ color: '#1a1a1a' }}>Sign up</Link>
          </Typography>
        </Box>
      </Box>
    </AuthLayout>
  )
}
